import * as React from "react";
import * as FreeScrollbars from "react-custom-scrollbars";
// import * as FreeScrollbars from "react-free-scrollbar";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { handleScroll, height, width } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name lodash
   * @infos "https://reactjs.org"
   */
  // className="freeScroll" onScrollbarScroll={handleScroll}
  return (
    <div style={{ height, width }}>
      <FreeScrollbars.default
        onScroll={handleScroll}
        autoHide={true}
        height={height}
        width={width}
      >
        {props.children}
      </FreeScrollbars.default>
    </div>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  handleScroll?: any;
  children?: any;
  height?: any;
  width?: any;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/scrollbars/component.tsx